module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAZCAYAAAAv3j5gAAAAAXNSR0IArs4c6QAAAL1JREFUSEvtlWEOwiAMhSkezHmIQTiNehrCTqEHk5qa1GSJrGUsxCXb3z3et76WDkynBzpxzP+BYoxDqfoQwkNKRl1Rmib8ZZYR78H72wEqJhBT+sZjAa4UGYs3jY5NCUgg75y6v3S2SkwH9gWirz1Ze5ZGFREHABDvjhvHC3vNouNYJJPNQEuN1vSIkxEr2j9IcxlrNTRUr5yfs2HQLMxWzWfqWk14BS359AVpfmqtmupdJ22N0vsDtDY58wZbpMkzQM/QfgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tree_gray.png
// module id = tKpz
// module chunks = 82